import { render, staticRenderFns } from "./SubjectOverview.vue?vue&type=template&id=e639d86c"
import script from "./SubjectOverview.vue?vue&type=script&lang=js"
export * from "./SubjectOverview.vue?vue&type=script&lang=js"
import style0 from "./SubjectOverview.vue?vue&type=style&index=0&id=e639d86c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports